/*
 * Transforms the snapshot to make it easier to work with in the application.
 */
export default function transformEventSnapshot(eventSnapshot) {
  return {
    ...eventSnapshot,
    // remove site editor from snapshot so that it isn't used by app
    siteEditor: null
  };
}
